<template>
	<div></div>
</template>
<script>
export default {
	// 打开页面加载的组件
	mounted: function() {
		this.getData(); // 获取数据
	},
	// 方法
	methods: {
		getData: function() {
			const self = this;
			self.$axios_api.oidcLogin({}).then(res => {
				window.location = res;
			})
		},
	}
};
</script>
